import { Helmet, HelmetData } from "react-helmet-async";

const SITE_NAME = "CarpHomes";
const DEFAULT_DESCRIPTION =
  "CarpHomes buys homes directly from homeowners in the Indianapolis area, offering speed, cash, and discretion. No commissions, no closing costs, no headaches.";
const SITE_URL = "https://carp-homes.com";

const helmetData = new HelmetData({}, true);

const Seo = ({ title, description = DEFAULT_DESCRIPTION, pathname = "" }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME}`;

  return (
    <Helmet helmetData={helmetData} defer={false}>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={`${SITE_URL}${pathname}`} />
    </Helmet>
  );
};

export default Seo;
